import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../../mfe/MfeLoader";
import { useViewport } from "../../../contexts/ViewportContext";
import { requireAuth } from "../../../utils/auth";

export const Route = createFileRoute("/admin/audit-trail/")({
  beforeLoad: requireAuth,
  component: AuditLogsMfePage,
});

function AuditLogsMfePage() {
  const { headerHeight } = useViewport();

  return (
    <div
      className="overflow-hidden"
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
    >
      <MfeLoader name="audit" />
    </div>
  );
}
